import { render, staticRenderFns } from "./ServiceVue.vue?vue&type=template&id=42c5fbc9&scoped=true"
import script from "./ServiceVue.vue?vue&type=script&lang=js"
export * from "./ServiceVue.vue?vue&type=script&lang=js"
import style0 from "./ServiceVue.vue?vue&type=style&index=0&id=42c5fbc9&prod&lang=scss&scoped=true"
import style1 from "./ServiceVue.vue?vue&type=style&index=1&id=42c5fbc9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c5fbc9",
  null
  
)

export default component.exports